import { ToolTipHeaderSelectWithStatus } from './tool-tip-header-select-with-status.model';


export class ToolTipHeaderSelectByIdOutput implements IToolTipHeaderSelectByIdOutput {
    status!: number;
    message!: string;
    data!: ToolTipHeaderSelectWithStatus;

    constructor(data?: IToolTipHeaderSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? ToolTipHeaderSelectWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ToolTipHeaderSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipHeaderSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IToolTipHeaderSelectByIdOutput {
    status: number;
    message: string;
    data: ToolTipHeaderSelectWithStatus;
}

